export const convertSize = (size?: string | number) => (typeof size === 'number' ? size / 16 + 'rem' : size)
